import { atom } from 'jotai';

const userLocationLoadingAtom = atom(false);

export default userLocationLoadingAtom;
